import React, { useState } from 'react'
import useInterval from 'use-interval'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  time: {
    textAlign: 'left',
    font: 'normal normal normal 11px Open Sans',
    letterSpacing: 0,
    color: '#707070',
    opacity: 1
  }
}))

/** @param {{ time: string | number | Date }} props */
export default function TimeSinceCalculator (props) {
  const classes = useStyles()
  const [update, setUpdate] = useState(false)

  const now = new Date()
  const diffMs = now - new Date(props.time)
  const minutes = diffMs / 60000
  const hours = minutes / 60
  const days = hours / 24
  const weeks = days / 7
  const months = days / 30
  const years = days / 365

  let displayTime = ''

  if (minutes < 0.5) {
    displayTime = 'Now'
  } else if (minutes < 60) {
    displayTime = Math.round(minutes) + ' min'
  } else if (days < 1) {
    const hrs = Math.round(hours)
    displayTime = hrs === 1 ? '1 hr' : hrs + ' hrs'
  } else if (weeks < 1) {
    const dys = Math.round(days)
    displayTime = dys === 1 ? '1 day' : dys + ' days'
  } else if (months < 1) {
    const wks = Math.round(weeks)
    displayTime = wks === 1 ? '1 week' : wks + ' wks'
  } else if (years < 1) {
    const mon = Math.round(months)
    displayTime = mon + ' mon'
  } else {
    const yrs = Math.round(years)
    displayTime = yrs === 1 ? '1 year' : yrs + ' yrs'
  }

  useInterval(() => {
    setUpdate(!update)
  }, 60000)

  return (
    <div className={classes.time}>
      {displayTime}
    </div>
  )
}
